import React, { useState, useCallback } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import WhyBulk from "@/components/landing/WhyBulk";
import HowItWorks from "@/components/landing/HowItWorks";
import DashboardSection from "@/components/landing/DashboardSection";
import ConnectedWorkspace from "@/components/landing/ConnectedWorkspace";
import Outcomes from "@/components/landing/Outcomes";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import LeadModal from "@/components/landing/LeadModal";

export default function BulkContainer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [intent, setIntent] = useState("create_workspace");

  const openLead = useCallback((nextIntent) => {
    setIntent(nextIntent || "create_workspace");
    setModalOpen(true);
  }, []);

  return (
    <div className="min-h-screen bg-white antialiased">
      <Navbar onOpenLead={openLead} />
      <main>
        <Hero onOpenLead={openLead} />
        <Problem />
        <WhyBulk />
        <HowItWorks />
        <DashboardSection />
        <ConnectedWorkspace />
        <Outcomes />
        <Faq />
        <FinalCta onOpenLead={openLead} />
      </main>
      <Footer />
      <LeadModal open={modalOpen} onOpenChange={setModalOpen} intent={intent} />
    </div>
  );
}
